var reviewPopup ={
    prefixReviewApiUrl : "/mkt/api/review/",    //리뷰 api prefix
    loginUrl: "/sso/member/login",  //로그인 url
    ownModelUrl:"/my-page/manage-products-reg-popup",
    closeResult : {
        reload : "N",
        resultCode : "SUCCESS",
        resultMsg : "close reviewForm"
    },
    isIOSApp:false,
    init : function(){
        if(vcui.detect.isIOS == true && isApp() ==true){
            this.isIOSApp = true;
        }
    },
    callAjax:function(callParam,param,callback){
        var type = callParam.type ? callParam.type : "POST";
        var contentType = callParam.contentType ? callParam.contentType : false;
        var async = callParam.async ? callParam.async : true;
        lgkorUI.showLoading();
        $.ajax({
            url: callParam.url,
            type: type,
            data: param,
            contentType: contentType,
            processData : false,
            async : async,
            cache : false,
            success: function (data) {
                lgkorUI.hideLoading();
                if (typeof callback == 'function') {
                    callback(data);
                }
            },
            error: function (e) {
                console.log(e);
                lgkorUI.hideLoading();
            }
        });
    },
    goPage:function(url){
        location.href = url;
    },
    windowClose:function(){
        if(window.opener){
            window.close();
        }
    },
    //리뷰 작성 팝업
    reviewFormPopup: function (param) {
        // console.log(param);
        /*
        reviewId : 수정일때 필수
        reviewPath
            "PDP"; //PDP
            "OWNMODEL";   //마이페이지 - 보유제품관리
            "ORDER"; //마이페이지 - 주문/배송조회
            "REVIEW";   //마이페이지 - 상품리뷰
            "ETC"; //기타
        modelId : modelId (옵션)
        sku : modelCode (옵션)
        gerpOrdNo : 주문에서 넘어옴 보유제품 등록시 넘겨주는 값(옵션)
        obsOrderNo : 주문에서 넘어옴 보유제품 등록시 넘겨주는 값(옵션)
        b2cYN : N 일때 사업자몰
        */
        var reviewId = param.reviewId;
        var reviewPath = param.reviewPath;
        var modelId = param.modelId;
        var sku = param.sku;
        var gerpOrdNo = param.gerpOrdNo;
        var obsOrderNo = param.obsOrderNo;
        var b2cYN = param.b2cYN;
        reviewPopup.callAjax({
            url : reviewPopup.prefixReviewApiUrl+"reviewCheck",
            contentType : "application/json; charset=UTF-8;",
        },JSON.stringify(param),function(data){
            if (data.resultCode == "SUCCESS") {
                var reviewFormUrl = "/mkt/review/" + data.reviewModel.modelId + "/reviewFormPopup";
                var queryString = "";
                for (key in param) {
                    if (queryString.length > 0) {
                        queryString = queryString + "&";
                    } else {
                        queryString = queryString + "?";
                    }
                    queryString = queryString + key + "=" + param[key];
                }
                reviewFormUrl = reviewFormUrl + queryString;
                window.open(reviewFormUrl, 'review_form_popup', 'width=695, height=788, top=50, left=50, scrollbars=yes, noopener=false');
            }else{
                reviewPopup.resultMsg(data);
            }
        });
    },
    resultMsg:function(reviewResult){
        // console.log(reviewResult);
        var resultMsg = reviewResult.resultMsg;
        var resultCode = reviewResult.resultCode;
        var detailCode = reviewResult.detailCode;
        var modelCode = "";
        if(reviewResult.reviewModel){
            modelCode = reviewResult.reviewModel.modelCode;
        }
        var gerpOrdNo = "";
        var obsOrderNo = "";
        var reviewPath = "PDP";
        var b2cYN = "";
        if(reviewResult.reviewParam){
            gerpOrdNo = reviewResult.reviewParam.gerpOrdNo;
            obsOrderNo = reviewResult.reviewParam.obsOrderNo;
            reviewPath = reviewResult.reviewParam.reviewPath;
            b2cYN = reviewResult.reviewParam.b2cYN;
        }

        if(resultCode != 'SUCCESS'){
            if(detailCode != null && detailCode != ''){
                lgkorUI.confirm(resultMsg, {
                    title: "",
                    cancelBtnName: "아니요",
                    okBtnName: "네",
                    ok:function(){
                        if(detailCode == 'notLogin'){
                            reviewPopup.goPage(reviewPopup.loginUrl);
                        }
                        if(detailCode == 'emptyOwnModel'){
                            var ownModelUrl = reviewPopup.ownModelUrl;
                            ownModelUrl += "?modelCode="+modelCode;
                            ownModelUrl += "&reviewYn=Y";
                            ownModelUrl += "&reviewPath="+reviewPath;
                            if(gerpOrdNo){
                                ownModelUrl += "&gerpOrdNo=" + gerpOrdNo;
                            }
                            if(obsOrderNo){
                                ownModelUrl += "&obsOrderNo=" + obsOrderNo;
                            }
                            if(b2cYN){
                                ownModelUrl += "&b2cYN="+b2cYN;
                            }
                            // console.log(ownModelUrl);
                            // reviewPopup.goPage(ownModelUrl);
                            window.open(ownModelUrl, 'own_model_popup', 'width=678, height=700, top=50, left=50, scrollbars=yes');
                        }
                    },
                    cancel:function(){
                        reviewPopup.closeResult.resultCode = "FAIL";
                        reviewPopup.closeResult.resultMsg = resultMsg;
                        reviewPopup.windowClose();
                    }
                });
            }else{
                lgkorUI.alert(resultMsg,{
                    ok:function(){
                        reviewPopup.closeResult.resultCode = "FAIL";
                        reviewPopup.closeResult.resultMsg = resultMsg;
                        reviewPopup.windowClose();
                    }
                });
            }
        }
    },
    reviewDeclairFormPopup: function (param) {
        reviewPopup.callAjax({
            url : reviewPopup.prefixReviewApiUrl+"reviewDeclairCheck",
            contentType : "application/json; charset=UTF-8;",
        },
            JSON.stringify(param),
            function(data) {
                // console.log(data);
                if (data.resultCode == "DUPLICATE") {
                    lgkorUI.alert("이미 신고된 리뷰입니다.<br>동일 리뷰는 1회만 신고 가능합니다.");
                } else if (data.resultCode == "NOT_LOGIN") {
                    lgkorUI.confirm("로그인 후 신고가 가능합니다.<br>로그인 하시겠습니까? ", {
                        title: "",
                        cancelBtnName: "아니요",
                        okBtnName: "네",
                        ok: function () {
                            reviewPopup.goPage(reviewPopup.loginUrl);
                        }
                    });
                } else if (data.resultCode == "SUCCESS") {
                    var url = "/mkt/review/" + param.reviewId + "/reviewDeclairPopup";
                    window.open(url, 'review_declair_form_popup', 'width=678, height=567, top=50, left=50, scrollbars=yes');
                }
            }
        );
    }
}
$(function(){
    reviewPopup.init();
});
